import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import QuickNav from "@/components/QuickNav";
import ServicesSection from "@/components/ServicesSection";
import VehicleSection from "@/components/VehicleSection";
import AboutSection from "@/components/AboutSection";
import BookingSection from "@/components/BookingSection";
import ContactSection from "@/components/ContactSection";
import PartnersSection from "@/components/PartnersSection";
import Footer from "@/components/Footer";
import PrivacyPolicy from "@/components/PrivacyPolicy";
import LegalNotice from "@/components/LegalNotice";

function HomePage() {
  return (
    <>
      <HeroSection />
      <QuickNav />
      <ServicesSection />
      <VehicleSection />
      <AboutSection />
      <BookingSection />
      <ContactSection />
      <PartnersSection />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-[#131313]">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
          <Route path="/mentions-legales" element={<LegalNotice />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
